<script>
    import { logEvent } from '$lib/utils/logs';

    export let feature = 'puzzles';
    export let h_level = 2;

    let class_name = '';
    export { class_name as class };
</script>

<aside class="allsome-banner {class_name}" aria-label="All/Some by Critikid">
    <div class="banner-layout">
        <div class="banner-copy">
            <svelte:element this={`h${h_level}`} class="logo-heading">
                <img
                    src="/puzzles/allsome-logo.svg"
                    alt="All/Some"
                    width="129.921875"
                    height="29"
                    class="logo"
                />
            </svelte:element>
            <p class="eyebrow">A puzzle game by Critikid</p>
            <p class="description">
                All dogs are living things. Some are huskies.<br />
                Can you put the circles in their place?
            </p>
        </div>
        <img
            src="/puzzles/allsome-circles.svg"
            alt="Four colored circles with the labels Huskies, Dachshunds, Dogs, and Living things."
            width="600"
            height="570"
            loading="lazy"
            class="illustration"
        />
        <a
            href="https://allsome.app/?ref=critikid-puzzles"
            class="play-link"
            on:click={() => logEvent('allsome-banner-click', { feature })}
        >
            Play all/some
        </a>
    </div>
</aside>

<style>
    .allsome-banner {
        container-type: inline-size;
        overflow: hidden;
        border: 1px solid #393450;
        border-radius: 1.5rem;
        background: #17142f;
        color: #f4f2ff;
    }

    .banner-layout {
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(220px, 38%);
        grid-template-areas:
            'copy illustration'
            'play illustration';
        gap: 1.5rem 1rem;
        padding: 2rem 2rem 2rem 3rem;
    }

    .banner-copy {
        grid-area: copy;
        align-self: end;
    }

    .logo-heading {
        margin: 0;
    }

    .logo {
        display: block;
        width: 180px;
        max-width: 100%;
        height: auto;
    }

    .eyebrow {
        margin: 0.25em 0 0;
        color: #c9c4dd;
        font-size: 0.875rem;
        font-weight: 600;
        letter-spacing: 0.04em;
    }

    .description {
        margin: 1.25rem 0 0;
        color: #d9d5e9;
        font-size: 1.125rem;
        line-height: 1.6;
        text-wrap: pretty;
    }

    .play-link {
        grid-area: play;
        place-self: start;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        padding: 0.875rem 1.5rem;
        border-radius: 999px;
        background: #bf83ff;
        color: #17142f;
        font-weight: 700;
        text-decoration: none;
        transition: background-color 150ms;
    }

    .play-link:hover {
        background: #d2a6ff;
    }

    .play-link:focus-visible {
        outline: 3px solid #f4f2ff;
        outline-offset: 5px;
    }

    .illustration {
        grid-area: illustration;
        display: block;
        width: 100%;
        max-width: 260px;
        height: auto;
        place-self: center;
    }

    @container (max-width: 639px) {
        .banner-layout {
            grid-template-columns: minmax(0, 1fr);
            grid-template-areas: 'copy' 'illustration' 'play';
            padding: 1.75rem 1.5rem;
            text-align: center;
        }

        .logo {
            margin-inline: auto;
        }

        .description {
            font-size: 1rem;
        }

        .play-link {
            justify-self: center;
        }
    }
</style>
